module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-72x72-ff8e3e91fa26ea8f237c1da1ed697ea2.png";